import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { AddIcon, RemoveIcon } from '../../components/Icons';
import { Button, Col, Row } from 'react-bootstrap';

const InlineItemForm = (props) => {
  const [inputList, setInputList] = useState([]);
  const [errors, setErrors] = useState([]);
  const [existingItems, setExistingItems] = useState([]);

  useEffect(() => {
    if (props.lineItemsData) {
      try {
        const parsedData = JSON.parse(props.lineItemsData);

        if (Array.isArray(parsedData)) {
          const formattedData = parsedData.map((item) => {
            const key = Object.keys(item)[0];
            return { itemName: key, price: item[key], isExisting: true };
          });

          setInputList(formattedData);
          setExistingItems(formattedData.map((item) => item.itemName));
          setErrors(formattedData.map(() => ({ itemName: "", price: "" })));
        }
      } catch (error) {
        console.error("Invalid JSON in lineItemsData:", error);
      }
    } else {
      setInputList([{ itemName: "", price: "", isExisting: false }]);
      setErrors([{ itemName: "", price: "" }]);
    }
  }, [props.lineItemsData]);

  const handleRemoveClick = (index) => {
    if (inputList[index].isExisting) return; // Prevent removing existing items

    const list = [...inputList];
    const errorsCopy = [...errors];

    // Get the price of the removed item BEFORE removing it
    const removedItemPrice = list[index].price ? parseFloat(list[index].price) : 0;

    // Update total price before modifying the list
    props.setInlineTotal((prevTotal) => prevTotal - removedItemPrice);
    props.setItemTotal((prevTotal) => prevTotal - removedItemPrice);

    // Remove the item from the list
    list.splice(index, 1);
    errorsCopy.splice(index, 1);

    setInputList(list);
    setErrors(errorsCopy);
  };


  const handleAddClick = () => {
    setInputList([...inputList, { itemName: "", price: "", isExisting: false }]);
    setErrors([...errors, { itemName: "", price: "" }]);
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    const errorsCopy = [...errors];

    list[index][name] = value;
    errorsCopy[index][name] = validateInput(name, value);

    setInputList(list);
    setErrors(errorsCopy);
  };

  const handlePriceKeyPress = (e) => {
    const isValidInput = /^[0-9\b]*(\.\d{0,4})?$/.test(e.target.value + e.key);
    if (!isValidInput) {
      e.preventDefault();
    }
  };

  const validateInput = (name, value) => {
    if (name === "itemName" && value.trim() === "") {
      return "Item Name is required";
    } else if (name === "price" && (value.trim() === "" || isNaN(parseFloat(value)))) {
      return "Price must be a valid number";
    }
    return "";
  };

  const handleSubmit = () => {
    const newlyAddedItems = inputList.filter((item) => !item.isExisting && item.itemName && item.price !== "");

    const totalPrice = newlyAddedItems.reduce((total, item) => total + parseFloat(item.price), 0);

    const validData = newlyAddedItems.map((item) => ({ [item.itemName]: item.price }));

    props.setInlineItem(validData);
    props.setInlineTotal(totalPrice);
    props.setItemTotal(inputList.reduce((sum, item) => sum + (item.price ? parseFloat(item.price) : 0), 0));
  };

  useEffect(() => {
    const validItems = inputList.filter((item) => item.itemName && item.price !== "");
    const validData = validItems.map((item) => ({ [item.itemName]: item.price }));

    if (validData.length < 1) {
      props.setInlineTotal(0);
    }
  }, [inputList]);

  return (
    <div className="w-100">
      {inputList.map((x, i) => (
        <div key={i} className="add-item-row">
          <div className="item-field">
            <Row className="g-3">
              <Col xs={6}>
                <Form.Label>Item Name</Form.Label>
                <Form.Control
                  type="text"
                  name="itemName"
                  placeholder="Item name here"
                  value={x.itemName}
                  onChange={(e) => handleInputChange(e, i)}
                  disabled={x.isExisting} // Disable editing for existing items
                />
                <p className="text-danger text-small">{errors[i].itemName}</p>
              </Col>
              <Col xs={6}>
                <Form.Label>Item Price</Form.Label>
                <Form.Control
                  type="text"
                  name="price"
                  value={x.price}
                  placeholder="Price here"
                  onChange={(e) => handleInputChange(e, i)}
                  onKeyPress={handlePriceKeyPress}
                  disabled={x.isExisting} // Disable editing for existing items
                />
                <p className="text-danger text-small">{errors[i].price}</p>
              </Col>
            </Row>
          </div>
          {!x.isExisting && ( // Only show remove button for new items
            <div className="action-btn" onClick={() => handleRemoveClick(i)}>
              <RemoveIcon />
            </div>
          )}
          {inputList.length - 1 === i && (
            <div className="action-btn" onClick={handleAddClick}>
              <AddIcon />
            </div>
          )}
        </div>
      ))}
      {inputList.length === 0 && (
        <div className="action-btn" onClick={handleAddClick}>
          <AddIcon />
          <span className="ms-2">Add Item</span>
        </div>
      )}
      <Button variant="primary" className="mt-2" onClick={handleSubmit}>
        Submit
      </Button>
    </div>
  );
};

export default InlineItemForm;
